module.exports = __webpack_public_path__ + "static/usta@2x-6a781c7d562a57b1153af9737728c2e2.png";